@if (oneFillingBox.show) {
  <icc-select-box [title]="oneFillingBox?.title"
    [description]="oneFillingBox?.name"
    [imageUrl]="oneFillingBox?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isFillingSelectionDisabled(oneFillingBox.boxType)"
    [buttonText2]="(oneFillingBox.type === 'deco_panels' && 'INTERFACE|Opcje' | translate) || (oneFillingBox.type === 'glazing' && !oneFillingBox.oneGlazing  && 'WINDOW|Wypełnienie per kwatera' | translate)"
    [descriptionTemplate]="fillingBoxTemplate"
    [descriptionContext]="{box: oneFillingBox}"
    (select)="openModalFilling(oneFillingBox.boxType)"
    (select2)="openModalDecoPanelOptions(oneFillingBox.boxType)"
  ></icc-select-box>
}
@if (doorActiveFillingBox.show) {
  <icc-select-box [title]="doorActiveFillingBox?.title"
    [description]="doorActiveFillingBox?.name"
    [imageUrl]="doorActiveFillingBox?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isFillingSelectionDisabled('doorActive')"
    [buttonText2]="doorActiveFillingBox.type === 'deco_panels' && 'INTERFACE|Opcje' | translate"
    [descriptionTemplate]="fillingBoxTemplate"
    [descriptionContext]="{box: doorActiveFillingBox}"
    (select)="openModalFilling('doorActive')"
    (select2)="openModalDecoPanelOptions('doorActive')"
  ></icc-select-box>
}
@if (doorPassiveFillingBox.show) {
  <icc-select-box [title]="doorPassiveFillingBox?.title"
    [description]="doorPassiveFillingBox?.name"
    [imageUrl]="doorPassiveFillingBox?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isFillingSelectionDisabled('doorPassive')"
    [buttonText2]="doorPassiveFillingBox.type === 'deco_panels' && 'INTERFACE|Opcje' | translate"
    [descriptionTemplate]="fillingBoxTemplate"
    [descriptionContext]="{box: doorPassiveFillingBox}"
    (select)="openModalFilling('doorPassive')"
    (select2)="openModalDecoPanelOptions('doorPassive')"
  ></icc-select-box>
}
@if (windowFillingBox.show) {
  <icc-select-box [title]="windowFillingBox?.title"
    [description]="windowFillingBox?.name"
    [imageUrl]="windowFillingBox?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isFillingSelectionDisabled('window')"
    [buttonText2]="windowFillingBox.type === 'deco_panels' && 'INTERFACE|Opcje' | translate"
    [descriptionTemplate]="fillingBoxTemplate"
    [descriptionContext]="{box: windowFillingBox}"
    (select)="openModalFilling('window')"
    (select2)="openModalDecoPanelOptions('window')"
  ></icc-select-box>
}
@if (hasWarmEdge$ | async) {
  <icc-select-box [title]="'WINDOW|Ramka szyby' | translate"
    [description]="(glazingSpacer$ | async)?.name"
    [imageUrl]="'/files/windowwarmedge/' + (glazingSpacer$ | async)?.image"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isWarmEdgeSelectionDisabled()"
    (select)="openModalWarmEdge()"
  ></icc-select-box>
}
@if (availableGlazingBead$ | async) {
  <icc-select-box [title]="'WINDOW|Listwa przyszybowa' | translate"
    [description]="(glazingBead$ | async)?.name"
    [imageUrl]="'/files/profile/' + (glazingBead$ | async)?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isGlazingBeadSelectionDisabled(undefined)"
    (select)="openModalGlazingBead()"
  ></icc-select-box>
}
@if (availableGlazingBeadSashes$ | async) {
  <icc-select-box [title]="'WINDOW|Listwa przyszybowa w skrzydłach' | translate"
    [description]="(glazingBeadInSashes$ | async)?.name"
    [imageUrl]="'/files/profile/' + (glazingBeadInSashes$ | async)?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isGlazingBeadSelectionDisabled('sashes')"
    (select)="openModalGlazingBead('sashes')"
  ></icc-select-box>
}
@if (availableGlazingBeadFix$ | async) {
  <icc-select-box [title]="'WINDOW|Listwa przyszybowa w stałym szkleniu' | translate"
    [description]="(glazingBeadInFix$ | async)?.name"
    [imageUrl]="'/files/profile/' + (glazingBeadInFix$ | async)?.img"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isGlazingBeadSelectionDisabled('fix')"
    (select)="openModalGlazingBead('fix')"
  ></icc-select-box>
}
@if (availableSealColor$ | async) {
  <icc-select-box [title]="'WINDOW|Kolor uszczelki' | translate"
    [description]="(sealColor$ | async)?.name"
    [imageUrl]="'/files/windowsealcolor/' + (sealColor$ | async)?.color_img"
    [color]="'#' + (sealColor$ | async)?.color"
    [colorSelect]="true"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isSealColorSelectionDisabled()"
    (select)="openModalSealColor()"
  ></icc-select-box>
}
@if (availableSiliconeColor$ | async) {
  <icc-select-box [title]="'WINDOW|Kolor silikonu' | translate"
    [description]="(siliconeColor$ | async)?.name"
    [imageUrl]="'/files/windowsiliconecolor/' + (siliconeColor$ | async)?.color_img"
    [color]="'#' + (siliconeColor$ | async)?.color"
    [colorSelect]="true"
    [buttonText]="'INTERFACE|Zmień' | translate"
    [disabledButton1]="isSiliconeColorSelectionDisabled()"
    (select)="openModalSiliconeColor()"
  ></icc-select-box>
}

<ng-template #fillingBoxTemplate let-box="box">
  @if (box.oneGlazing && box.type != 'deco_panels') {
    <p class="glassTypeDescription"
      >
      {{box.name}}<br>
      U<sub>g</sub> = {{box.u}}
      @if (box.bondedGlazing) {
        <span>
          <br>
            {{ 'WINDOW|Wklejane szyby' | translate }}
          </span>
        }
        @if (box.bondedGlazing && box.partlyBondedGlazing) {
          <span>
            <br>
              {{ 'WINDOW|Wklejane szyby w części kwater.' | translate }}
            </span>
          }
        </p>
      }
      @if (box.oneGlazing && box.type == 'deco_panels') {
        <p class="glassTypeDescription"
          >
          <span><b>{{ 'WINDOW|Rodzaj:' | translate }}</b>&nbsp;
          @if (box.panelType == 'Inset') {
            <span>{{'DOOR|Wypełnienie wsadowe' | translate }}</span>
          }
          @if (box.panelType == 'Outer') {
            <span>{{'DOOR|Nakładka zewnętrzna' | translate }}</span>
          }
          @if (box.panelType == 'Double') {
            <span>{{'DOOR|Nakładka obustronna' | translate }}</span>
          }
          @if (box.panelType == 'Inner') {
            <span>{{'DOOR|Nakładka wewnętrzna' | translate }}</span>
          }
          <br>
          </span>
          <span><b>{{ 'DOOR|Model:' | translate }}</b>&nbsp;{{box.name}}<br></span>
          @if (box.panelGlazingName) {
            <span><b>{{ 'DOOR|Szklenie:' | translate }}</b>&nbsp;{{box.panelGlazingName}}<br></span>
          }
          <span><b>{{ 'DOOR|Kolor wypełnienia:' | translate }}</b>&nbsp;{{box.color}}<br></span>
          @if (box.color2) {
            <span><b>{{ 'DOOR|Kolor wypełnienia 2:' | translate }}</b>&nbsp;{{box.color2}}<br></span>
          }
        </p>
      }
      @if (!box.oneGlazing) {
        <p class="glassTypeDescription">
          {{ 'DOOR|Różne pakiety w poszczególnych kwaterach, szczegóły w podsumowaniu.' | translate }}
        </p>
      }
    </ng-template>
